var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#285680",
    points: "255.998,509.595 476.687,288.906 364.33,176.548 255.998,284.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#18384C",
    points: "334.689,206.191 447.046,318.549 476.689,288.906 364.332,176.548"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4482C3",
    points: "255.998,511.997 97.101,511.997 35.308,158.894 97.101,52.963 255.998,52.963"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#285680",
    points: "220.687,167.721 176.55,203.032 132.412,167.721 132.412,97.101 220.687,97.101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4482C3",
    d: "M185.377,141.239c0,4.873-3.955,8.828-8.828,8.828c-4.873,0-8.828-3.955-8.828-8.828c0-4.873,3.955-8.828,8.828-8.828C181.422,132.411,185.377,136.366,185.377,141.239"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#285680",
    points: "97.101,52.966 255.998,52.966 255.998,0 97.101,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#18384C",
    points: "141.239,52.966 158.894,52.966 158.894,0 141.239,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#18384C",
    points: "194.205,52.966 211.86,52.966 211.86,0 194.205,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeans);
export default __webpack_public_path__ + "static/media/jeans.cea43930ae359f996159737c335bc622.svg";
export { ForwardRef as ReactComponent };